import { SplashScreen } from '@capacitor/splash-screen';
import { BiometricStorageProvider } from '@front-end/core/services';

export const initApp =
  // BiometricEnrollmentService is injected here only to force eager instantiation.
  // Its constructor subscribes to BiometricStorageProvider.enrollmentNeeded$ so the
  // subscription must be active before the user can log in.
  (biometricStorage: BiometricStorageProvider) => async () => {
    await SplashScreen.hide();

    /**
     * Show the splashscreen. It's not the native splashscreen, but a simple
     * native page with the same image shown in the native splashscreen.
     */
    await SplashScreen.show({
      autoHide: false,
    });

    /**
     * Populate the in-memory refresh token cache via biometric auth.
     * Must run before AppComponent.ngOnInit() calls authService.initialize().
     */
    await biometricStorage.initialize();
  };
